export const shouldHandleError = (error: unknown) => {
  if (error instanceof DOMException && error.name === 'NotAllowedError') {
    return false;
  }

  return true;
};
